import React from "react";
// import { useDispatch, useSelector } from "react-redux";
// import _ from "lodash";
import { Outlet } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

// import {
//   saveValue,
//   userDetailsSelector,
// } from "../store/slices/applicationFormSlice";

export default function Main(props) {
  return (
    <>
      <Container maxWidth="lg" style={{ height: "100%", padding: "0 50px" }}>
        {/* <Grid container style={{ height: "100%" }}> */}
        <Grid item xs={12}>
          {/* <Application {...props} /> */}
          <Outlet />
        </Grid>
        {/* </Grid> */}
      </Container>
    </>
  );
}
